import { env } from './env';

export const API_BASE_URL = env.apiBaseUrl;

export const API_ENDPOINTS = {
  // Orders
  ORDERS: '/AdminOrder',
  ORDER_DETAILS: (id: number) => `/AdminOrder/${id}`,
  
  // Ship For Me
  SHIP_FOR_ME: '/AdminShipForMe',
  SHIP_FOR_ME_DETAILS: (id: number) => `/AdminShipForMe/${id}`,
  
  // Invoices
  INVOICES: '/Invoice',
  INVOICE_DETAILS: (id: number) => `/Invoice/${id}`,
  
  // Payment Statistics
  PAYMENT_STATS: '/PaymentTransaction/statistics',
};

export const getApiUrl = (endpoint: string): string => {
  return `${API_BASE_URL}${endpoint}`;
};

